import Repository from './Repository';
const resource = '/content/article/banner';

export default {
  get(queryString = '') {
    return Repository.get(`${resource}${queryString}`);
  }
};
